import { ProductType } from "elephant-web/gql";
import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_VMP_COLLECTION_NAME = "vmp";

export const useRxCollectionVmp = (): RxCollection<Vmp> | null =>
  useRxCollection<Vmp>(RXDB_VMP_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Vmp>>;
export type VmpQueryConstructor = UseRxData["1"];

const VMP_SCHEMA_LITERAL = {
  title: "vmp schema",
  version: 2,
  description: "Represents a Vmp",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    productType: {
      type: "string",
      enum: Object.values(ProductType),
    },
    title: {
      type: "string",
    },
    keywords: {
      type: "array",
      items: {
        type: "string",
      },
    },
    snomedId: {
      type: ["string", "null"],
    },
    formId: {
      type: "string",
    },
    categoryId: {
      type: ["string", "null"],
    },
    legacyMedicationId: {
      type: ["string", "null"],
    },
    vtmId: {
      type: "string",
    },
  },
  required: [
    "id",
    "meta",
    "productType",
    "title",
    "keywords",
    "snomedId",
    "formId",
    "categoryId",
    "vtmId",
  ],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(VMP_SCHEMA_LITERAL);

export type Vmp = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const VMP_SCHEMA: RxJsonSchema<Vmp> = VMP_SCHEMA_LITERAL;
